import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Emit } from 'vue-property-decorator';

var DatePicker = /*#__PURE__*/function (_Vue) {
  _inherits(DatePicker, _Vue);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.apply(this, arguments);
    _this.date = new Date();
    return _this;
  }

  _createClass(DatePicker, [{
    key: "dateChange",
    value: function dateChange(val) {
      return val;
    }
  }, {
    key: "minusDate",
    value: function minusDate() {
      this.date = this.$moment(this.date).subtract(1, 'days').format('YYYY/MM/DD HH:mm:ss');
      this.dateChange(this.date);
    }
  }, {
    key: "plusDate",
    value: function plusDate() {
      this.date = this.$moment(this.date).add(1, 'days').format('YYYY/MM/DD HH:mm:ss');
      this.dateChange(this.date);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.date = new Date();
    }
  }, {
    key: "dateContent",
    get: function get() {
      return this.$moment(this.date).format('YYYY-MM-DD');
    }
  }]);

  return DatePicker;
}(Vue);

__decorate([Emit('change')], DatePicker.prototype, "dateChange", null);

DatePicker = __decorate([Component], DatePicker);
export default DatePicker;